<script lang="ts" setup>
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { onBeforeMount, ref } from "vue";
import { useCoinRank } from "@/stores/coinRank";

const coinRankStore = useCoinRank();

const loading = ref(false);
onBeforeMount(async () => {
  loading.value = true;
  try {
    await coinRankStore.getOrFetchHistoryCoinRank();
  } finally {
    loading.value = false;
  }
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <threads-nav show-back :show-center="false"> </threads-nav>
    <div class="h-full overflow-hidden">
      <!-- <div class="text-2xl font-bold text-center mb-5">冒险家排行榜</div> -->
      <div
        v-if="loading"
        class="flex items-center justify-center w-full h-full"
      >
        <span class="loading"></span>
      </div>
      <SeasonRankHome v-else class="h-full" />
    </div>
  </div>
</template>
